import React from 'react';
import { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import FontFaceObserver from 'fontfaceobserver';

const Loading = () => {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    const font = new FontFaceObserver('Raleway Dots');

    font
      .load()
      .then(() => {
        setFontLoaded(true);
      })
      .catch(() => {
        setFontLoaded(true); // Fallback if font fails to load
      });
  }, []);

  if (!fontLoaded) {
    return null; // Or a fallback spinner/loading indicator
  }
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Typography
        variant='h6'
        noWrap
        component='div'
        sx={{
          ml: { xs: 1, sm: 1, md: 1, lg: 0.55, xl: 0 },
          mr: { xs: 1, sm: 1, md: 1, lg: 12, xl: 12 },
          display: { xs: 'flex', md: 'flex' },
          // fontFamily: 'Raleway Dots, cursive',
          fontFamily: 'Montserrat',
          // fontWeight: { xs: 900, md: 1000, lg: 1000, xl: 1000 },
          // textShadow: '0px 0px 0px black',
          letterSpacing: '.3rem',
          fontSize: { xs: 18, sm: 19, md: 22, lg: 24, xl: 26 },
          color: 'black',
          textDecoration: 'none',
        }}
      >
        Xploras360
      </Typography>
    </Box>
  );
};

export default Loading;
